/* ==========================================================================
   Catalog pages (sections/dm-collection-main.liquid, dm-search-main.liquid)
   --------------------------------------------------------------------------
   Everything works without this file: chips, sort, tabs and "Show more" are
   plain links and forms. This script makes them faster and keeps place:

   1. Chips, sort and Clear re-render the section through the Section
      Rendering API and push the URL; Back restores the previous state.
   2. "Show more" / "Show previous" add the next or previous page in place and
      keep ?page=N in the URL.
   3. Collections: suggest the visitor's car, from the header's recent-cars
      list (localStorage "dm:cars", written by assets/dm-header.js). Suggest
      only; never filter silently.
   4. Search: the other tab's count, the top install guides on the Parts tab,
      and "Jump to" chips for matching collections and car pages.
   5. Chat buttons open the Missive chat on a topic; click events go to the
      dataLayer.

   Several sections include this file, so it guards against running twice.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__dmCatalog) return;
  window.__dmCatalog = true;

  var d = document;
  var cache = new Map();
  var navController = null;

  function track(name, label, extra) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: name, catalog_label: label || '' };
    if (extra) {
      for (var key in extra) payload[key] = extra[key];
    }
    window.dataLayer.push(payload);
  }

  function withParam(url, key, value) {
    var u = new URL(url, window.location.href);
    u.searchParams.set(key, value);
    return u.toString();
  }

  function fetchHtml(url, signal) {
    if (cache.has(url)) return Promise.resolve(cache.get(url));
    return fetch(url, { credentials: 'same-origin', signal: signal }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.text().then(function (html) {
        var entry = { html: html, url: res.url };
        cache.set(url, entry);
        return entry;
      });
    });
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function rootOf(el) {
    return el.closest('[data-dmc-root]');
  }

  /* ------------------------------------------------------------------------
     1. Re-render the section for a new URL (chips, sort, Clear, Back)
     ------------------------------------------------------------------------ */

  function render(root, url, options) {
    options = options || {};
    var sectionId = root.getAttribute('data-dmc-section');
    if (!sectionId) {
      window.location.assign(url);
      return;
    }

    if (navController) navController.abort();
    navController = 'AbortController' in window ? new AbortController() : null;
    root.setAttribute('aria-busy', 'true');
    root.classList.add('is-loading');

    fetchHtml(withParam(url, 'section_id', sectionId), navController ? navController.signal : undefined)
      .then(function (entry) {
        var next = parse(entry.html).querySelector('[data-dmc-root]');
        if (!next) throw new Error('No section in response');

        // Tag-route guard: an unknown tag redirects to the whole collection.
        // Chips only link to tags that exist here, but never show an
        // unfiltered grid as if it were filtered.
        if (options.expect != null) {
          var applied = next.getAttribute('data-dmc-tags') || '';
          if (applied !== options.expect) {
            window.location.assign(url);
            return;
          }
        }

        root.replaceWith(next);
        if (options.push) window.history.pushState({ dmc: true }, '', url);
        afterRender(next);

        var controls = next.querySelector('.dmc-controls') || next;
        if (controls.getBoundingClientRect().top < 0) controls.scrollIntoView({ block: 'start' });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        window.location.assign(url);
      });
  }

  d.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-dmc-nav]');
    if (!link || event.defaultPrevented) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var root = rootOf(link);
    if (!root) return;
    event.preventDefault();
    var expect = link.hasAttribute('data-dmc-expect') ? link.getAttribute('data-dmc-expect') : null;
    track('catalog_filter', link.textContent.trim());
    render(root, link.href, { push: true, expect: expect });
  });

  d.addEventListener('change', function (event) {
    var select = event.target;
    if (!select.matches || !select.matches('[data-dmc-sort] select')) return;
    var form = select.form;
    var root = rootOf(form);
    var url = new URL(form.getAttribute('action'), window.location.href);
    new FormData(form).forEach(function (value, key) {
      url.searchParams.set(key, value);
    });
    track('catalog_sort', select.value);

    // Search keeps Best match on its own template (see dm-search-main):
    // an option can name the view it belongs to.
    var option = select.options[select.selectedIndex];
    if (option && option.hasAttribute('data-dmc-view')) {
      var view = option.getAttribute('data-dmc-view');
      var currentView = new URL(window.location.href).searchParams.get('view') || '';
      if (view) url.searchParams.set('view', view);
      else url.searchParams.delete('view');
      if (select.value === 'best-match') url.searchParams.delete('sort_by');
      if (view !== currentView) {
        window.location.assign(url.toString());
        return;
      }
    }

    if (root) render(root, url.toString(), { push: true });
    else window.location.assign(url.toString());
  });

  window.addEventListener('popstate', function () {
    var root = d.querySelector('[data-dmc-root]');
    if (root) render(root, window.location.href, {});
  });

  /* ------------------------------------------------------------------------
     2. Show more / Show previous
     ------------------------------------------------------------------------ */

  function progressText(from, to, total) {
    return 'Showing ' + (from > 1 ? from + '–' : '') + to + ' of ' + total;
  }

  function loadPage(link, direction) {
    var root = rootOf(link);
    var grid = root && root.querySelector('[data-dmc-grid]');
    if (!root || !grid) return false;
    var sectionId = root.getAttribute('data-dmc-section');
    var target = link.href;
    var label = link.textContent;
    link.setAttribute('aria-busy', 'true');
    link.textContent = 'Loading…';

    fetchHtml(withParam(target, 'section_id', sectionId))
      .then(function (entry) {
        var doc = parse(entry.html);
        var nextGrid = doc.querySelector('[data-dmc-grid]');
        if (!nextGrid) throw new Error('No grid');
        var items = Array.prototype.filter.call(nextGrid.children, function (item) {
          return !item.classList.contains('dmc-help') && !item.classList.contains('dms-guides');
        });
        var fragment = d.createDocumentFragment();
        var firstNew = null;
        items.forEach(function (item) {
          var node = d.importNode(item, true);
          if (!firstNew) firstNew = node;
          fragment.appendChild(node);
        });

        var progress = root.querySelector('[data-dmc-progress]');
        var loaded = doc.querySelector('[data-dmc-progress]');

        if (direction === 'next') {
          grid.appendChild(fragment);
          if (progress && loaded) {
            progress.setAttribute('data-dmc-to', loaded.getAttribute('data-dmc-to'));
          }
          var nextLink = doc.querySelector('[data-dmc-next]');
          if (nextLink) {
            link.href = nextLink.href;
            link.textContent = label;
            link.removeAttribute('aria-busy');
          } else {
            link.remove();
          }
          if (firstNew && link.matches && link.matches(':focus-visible')) {
            var focusTarget = firstNew.querySelector('a');
            if (focusTarget) focusTarget.focus();
          }
        } else {
          grid.insertBefore(fragment, grid.firstChild);
          if (progress && loaded) {
            progress.setAttribute('data-dmc-from', loaded.getAttribute('data-dmc-from'));
          }
          var prevLink = doc.querySelector('[data-dmc-prev]');
          if (prevLink) {
            link.href = prevLink.href;
            link.textContent = label;
            link.removeAttribute('aria-busy');
          } else {
            link.closest('.dmc-pager').remove();
          }
        }

        if (progress) {
          progress.textContent = progressText(
            parseInt(progress.getAttribute('data-dmc-from'), 10) || 1,
            parseInt(progress.getAttribute('data-dmc-to'), 10) || 0,
            parseInt(progress.getAttribute('data-dmc-total'), 10) || 0
          );
        }

        window.history.replaceState({ dmc: true }, '', target);
        track(direction === 'next' ? 'catalog_show_more' : 'catalog_show_previous', String(items.length));
      })
      .catch(function () {
        window.location.assign(target);
      });
    return true;
  }

  d.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-dmc-next], [data-dmc-prev]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
    if (link.getAttribute('aria-busy') === 'true') {
      event.preventDefault();
      return;
    }
    var direction = link.hasAttribute('data-dmc-next') ? 'next' : 'prev';
    if (loadPage(link, direction)) event.preventDefault();
  });

  /* ------------------------------------------------------------------------
     3. Collections: suggest the visitor's car
     ------------------------------------------------------------------------ */

  function readCars() {
    try {
      return JSON.parse(window.localStorage.getItem('dm:cars') || '[]') || [];
    } catch (e) {
      return [];
    }
  }

  function suggestCar(root) {
    var slot = root.querySelector('[data-dmc-mycar]');
    if (!slot) return;
    var group = slot.closest('[data-dmc-group="car"]');
    if (!group || group.querySelector('[data-dmc-car].is-active')) return;

    var car = readCars()[0];
    if (!car || !car.t) return;
    // "992.1 GT3" matches the 992.1 chip; "996 GT3" or "718 GT4 RS" match the
    // one chip of that chassis. A bare "992 GT3" could be either generation,
    // so it suggests nothing rather than guess.
    var title = String(car.t);
    var chips = Array.prototype.slice.call(group.querySelectorAll('[data-dmc-car]'));
    var exact = title.match(/\b(99\d\.\d)\b/);
    var chip = null;
    if (exact) {
      chip = chips.filter(function (c) { return c.getAttribute('data-dmc-car') === exact[1]; })[0] || null;
    } else {
      var family = title.match(/\b(99\d|718|981|987)\b/);
      if (family) {
        var hits = chips.filter(function (c) {
          var tag = c.getAttribute('data-dmc-car');
          return tag === family[1] || tag.indexOf(family[1] + '.') === 0;
        });
        if (hits.length === 1) chip = hits[0];
      }
    }
    if (!chip) return;

    var link = d.createElement('a');
    link.href = chip.href;
    link.setAttribute('data-dmc-nav', '');
    link.setAttribute('data-dmc-expect', chip.getAttribute('data-dmc-expect') || '');
    link.className = 'dmc-mycar__link';
    link.textContent = 'Only parts for your ' + car.t;
    slot.textContent = '';
    slot.appendChild(link);
    slot.hidden = false;
  }

  /* ------------------------------------------------------------------------
     4. Search: other tab's count, guides strip, jump-to chips
     ------------------------------------------------------------------------ */

  function initSearch(root) {
    var terms = root.getAttribute('data-dms-terms');
    if (!terms) return;
    var tab = root.getAttribute('data-dms-tab');
    var other = tab === 'article' ? root.getAttribute('data-dms-parts-url') : root.getAttribute('data-dms-guides-url');
    var otherType = tab === 'article' ? 'product' : 'article';

    fetchHtml(withParam(other, 'section_id', 'dm-search-guides'))
      .then(function (entry) {
        var endpoint = parse(entry.html).querySelector('[data-dms-endpoint]');
        if (!endpoint) return;
        var count = parseInt(endpoint.getAttribute('data-dms-count'), 10) || 0;
        var countEl = root.querySelector('[data-dms-count="' + otherType + '"]');
        if (countEl) countEl.textContent = String(count);

        var strip = root.querySelector('[data-dms-guides]');
        var list = endpoint.querySelector('.dms-articles');
        if (strip && otherType === 'article' && count > 0 && list) {
          var heading = d.createElement('div');
          heading.className = 'dms-guides__head';
          heading.innerHTML = '<p class="dms-guides__title"></p><a class="dms-guides__all"></a>';
          heading.querySelector('.dms-guides__title').textContent = 'Guides for “' + terms + '”';
          var all = heading.querySelector('.dms-guides__all');
          all.href = other;
          all.textContent = count > 3 ? 'All ' + count + ' guides' : 'See guides';
          strip.appendChild(heading);
          strip.appendChild(d.importNode(list, true));
          strip.hidden = false;
        }
      })
      .catch(function () {});

    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var words = terms.split(/\s+/).filter(Boolean);

    // Predictive search needs every word to match, so "992 gt3 wing" finds no
    // collection while "992 gt3" does. Drop trailing words, at most twice.
    function suggest(attempt) {
      var q = words.slice(0, words.length - attempt).join(' ');
      if (!q) return;
      var url = rootUrl + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources%5Btype%5D=collection,page&resources%5Blimit%5D=4';
      fetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          var results = data && data.resources && data.resources.results;
          var pages = (results && results.pages) || [];
          var collections = (results && results.collections) || [];
          if (!pages.length && !collections.length) {
            if (attempt < 2 && words.length - attempt > 1) suggest(attempt + 1);
            return;
          }
          renderJump(pages, collections);
        })
        .catch(function () {});
    }

    function renderJump(pages, collections) {
      var wrap = root.querySelector('[data-dms-jump]');
      var row = root.querySelector('[data-dms-jump-row]');
      if (!wrap || !row) return;
      var items = pages.slice(0, 2).map(function (p) { return { item: p, page: true }; })
        .concat(collections.map(function (c) { return { item: c, page: false }; }))
        .slice(0, 4);
      items.forEach(function (entry) {
        var item = entry.item;
        if (!item.url || !item.title) return;
        var a = d.createElement('a');
        a.className = 'dmc-chip dmc-chip--jump';
        a.href = item.url.split('?')[0];
        a.textContent = item.title;
        if (entry.page) {
          var tag = d.createElement('span');
          tag.className = 'dmc-chip__tag';
          tag.textContent = 'Car page';
          a.appendChild(tag);
        }
        a.setAttribute('data-dmc-event', 'search_jump_click');
        a.setAttribute('data-dmc-label', item.title);
        row.appendChild(a);
      });
      wrap.hidden = row.children.length === 0;
    }

    suggest(0);
  }

  /* ------------------------------------------------------------------------
     5. Chat buttons and click events
     ------------------------------------------------------------------------ */

  d.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-dmc-chat]');
    if (!link) return;
    var topic = link.getAttribute('data-dmc-chat');
    var trigger = null;
    var topics = d.querySelectorAll('.dmx-chat__topic[data-topic]');
    for (var i = 0; i < topics.length; i++) {
      if (topics[i].getAttribute('data-topic') === topic) trigger = topics[i];
    }
    if (!trigger) trigger = d.getElementById('dmx-chat-btn');
    var missive = window.MissiveChat && typeof window.MissiveChat.open === 'function';
    if (!trigger && !missive) return;
    event.preventDefault();
    // After this click finishes bubbling: the chat closes its menu on any
    // document click outside itself.
    setTimeout(function () {
      if (trigger) trigger.click();
      else window.MissiveChat.open();
    }, 0);
  });

  d.addEventListener('click', function (event) {
    var el = event.target.closest && event.target.closest('[data-dmc-event], [data-dmc-card-link]');
    if (!el) return;
    if (el.hasAttribute('data-dmc-card-link')) {
      var card = el.closest('[data-dmc-card]');
      var grid = card && card.parentElement;
      var position = grid ? Array.prototype.indexOf.call(grid.querySelectorAll('[data-dmc-card]'), card) + 1 : 0;
      var title = el.querySelector('.dmc-card__title');
      track('catalog_card_click', title ? title.textContent.trim() : '', { catalog_position: position });
      return;
    }
    track(el.getAttribute('data-dmc-event'), el.getAttribute('data-dmc-label') || '');
  });

  /* ------------------------------------------------------------------------
     Init
     ------------------------------------------------------------------------ */

  function afterRender(root) {
    if (root.getAttribute('data-dmc-kind') === 'collection') suggestCar(root);
    if (root.getAttribute('data-dmc-kind') === 'search') initSearch(root);
  }

  function init() {
    d.querySelectorAll('[data-dmc-root]').forEach(afterRender);
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();

  d.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-dmc-root]');
    if (root) afterRender(root);
  });
})();
